import React from 'react';

import { cx } from '@travel/utils';

import styles from './customReviewBar.module.scss';

export type Props = {
  /** Custom style for bar container */
  barContainerClassName?: string;

  /** Custom style for bar score bar */
  barClassName?: string;

  /** Custom style for actual bar length */
  barLengthClassName?: string;

  /** The label text  */
  text?: React.ReactNode;

  /** The rating value */
  score: number | null;

  /** The maximum value of score */
  max: number;

  /** Whether animate or not */
  hasAnimation?: boolean;
};

function CustomReviewBar(props: Props) {
  const { barContainerClassName, score, max, hasAnimation, barLengthClassName, barClassName } =
    props;

  if (score === null) return null;

  return (
    <div
      className={cx(barContainerClassName, styles.barContainer)}
      data-testid="customReviewBar-wrapper"
    >
      <div className={cx(barLengthClassName, styles.barLength)}>
        <div className={styles.outer}>
          <div
            className={cx(barClassName, styles.inner, hasAnimation && styles.animated)}
            style={{ width: `${(score / max) * 100}%` }}
          />
        </div>
      </div>
    </div>
  );
}

export default CustomReviewBar;
